import React from "react"
import { Box } from "@chakra-ui/react"

import CampaignRow from "./CampaignRow"
import CalloutCampaignRow from "./CalloutCampaignRow"
import CalloutRow from "./CalloutRow"

export interface CalloutsProps {
  rows: GatsbyTypes.SanitySectionCallouts["rows"]
  theme: "Dark" | "Light"
  spacing?: "large" | "small"
  ctaToggle?: "On" | "Off"
}

const renderCalloutRow = (row: any, spacing: "large" | "small", ctaToggle: "On" | "Off", idx: number) => {
  switch (row._type) {
    case "calloutRow": {
      return <CalloutRow key={idx} callouts={row.callouts} spacing={spacing} toggle={ctaToggle} />
    }
    case "calloutCampaignRow": {
      return <CalloutCampaignRow key={idx} callout={row.callout} images={row.images} toggle={ctaToggle} />
    }
    case "campaignRow": {
      return <CampaignRow key={idx} images={row.images} carouselSettings={row.carouselSettings} toggle={ctaToggle} />
    }
    default:
      return <></>
  }
}

const Callouts = ({ rows, theme, spacing = "large", ctaToggle = "On" }: CalloutsProps) => (
  <Box as="section" bg={theme === "Dark" ? "brand.beige.dark" : "white"} pt={spacing === "large" ? 2.5 : 0} pb={[0, 2.5]}>
    {rows?.map((row, idx) => renderCalloutRow(row, spacing, ctaToggle, idx))}
  </Box>
)

export default Callouts
